module.exports = __webpack_public_path__ + "media/property_transaction_process/contract-0140f3cc.svg";